import React from "react";
import PropTypes from "prop-types";
import linkedInIcon from "../images/socials/linkedin.svg";
import envelopeIcon from "../images/socials/envelope.svg";
import gitHubIcon from "../images/socials/github.svg";
import image from "../images/PhilipBasnightCrop600.png";

const imageAltText = "Philip Basnight";

const Home = ({ name, title }) => {
  return (
    <section id="home" className="dark">
      <div className="hero-text">
        <img className="profile-pic" src={image} alt={imageAltText} />
        <h1>{name}</h1>
        <p className="hero-title">{title}</p>
        <div className="hero-socials">
          <a href="https://github.com/phizbiz" target="_blank" rel="noopener noreferrer" className="homeSocials">
            <img src={gitHubIcon} alt="GitHub" className="socialIcon" />
          </a>
          <a href="https://www.linkedin.com/in/philip-basnight" target="_blank" rel="noopener noreferrer" className="homeSocials">
            <img src={linkedInIcon} alt="LinkedIn" className="socialIcon" />
          </a>
          <a href="mailto:philipbasnight@gmail.com" className="homeSocials">
            <img src={envelopeIcon} alt="email" className="socialIcon" />
          </a>
        </div>
      </div>
    </section>
  );
};

Home.defaultProps = {
  name: "",
  title: "",
};

Home.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Home;
